module.exports = __webpack_public_path__ + "img/contact.600dcaee.svg";